import { HelpCircle } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";
import { Article } from "../../support.types";

type Props = {
  title: string;
  articles: Article[];
  onOpenArticle: (article: Article) => void;
};

export function SupportArticleList({
  title,
  articles,
  onOpenArticle = () => {},
}: Props) {
  return (
    <div className="flex flex-col flex-1 gap-6 w-full md:max-w-[420px]">
      <Type variant="h5">{title}</Type>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex flex-col gap-4">
          {articles.length === 0 ? (
            <Type variant="body2" className="text-brand-600">
              No articles found
            </Type>
          ) : (
            articles.map((article) => (
              <Button
                key={article.title}
                iconComponent={HelpCircle}
                variant="link-light"
                className="items-start justify-start p-0 whitespace-normal break-words text-brand-700 hover:text-brand-800"
                onClick={() => onOpenArticle(article)}
                data-testid={`support-article-list-${article.slug}`}
              >
                {article.title}
              </Button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportArticleList;
